module.exports = require("graphql");